import { SessionManager } from './session';
import { EventTracker } from './eventTracker';
import { CartTracker } from './cartTracker';
import { UserTracker } from './userTracker';
import { PageTracker } from './pageTracker';

/**
 * Clase principal de Tracking que proporciona acceso a todas las funcionalidades
 * de seguimiento del embudo de ventas.
 */
class TrackingManager {
  private static instance: TrackingManager;
  
  public session: SessionManager;
  public events: EventTracker;
  public cart: CartTracker;
  public user: UserTracker;
  public page: PageTracker;
  
  
  /**
   * Constructor privado para el patrón Singleton
   */
  private constructor(apiUrl: string = 'https://api.jarad.beeapp.es/api/v1') {
    apiUrl = import.meta.env.DEV === true ? 'http://localhost:5001/api/v1' : apiUrl;
    // Inicializar los diferentes trackers
    this.session = new SessionManager(apiUrl);
    this.events = new EventTracker(apiUrl, this.session);
    this.cart = new CartTracker(apiUrl, this.events);
    this.user = new UserTracker(apiUrl, this.session, this.events);
    this.page = new PageTracker(apiUrl, this.events);
  }
  
  /**
   * Obtener la instancia del TrackingManager (Singleton)
   */
  public static getInstance(apiUrl?: string): TrackingManager {
    if (!TrackingManager.instance) {
      TrackingManager.instance = new TrackingManager(apiUrl);
    }
    return TrackingManager.instance;
  }
  
  /**
   * Inicializar el sistema de tracking
   * @returns {Promise<void>}
   */
  async initialize(): Promise<void> {
    try {
      // Inicializar la sesión
      await this.session.initialize();
      
      // Inicializar el seguimiento de páginas
      this.page.initialize();
      
      console.log('TrackingManager initialized successfully');
    } catch (error) {
      console.error('Failed to initialize TrackingManager:', error);
    }
  }
}

// Exportar la instancia singleton por defecto
export default TrackingManager.getInstance();

// Exportar clases individuales para uso avanzado
export {
  SessionManager,
  EventTracker,
  CartTracker,
  UserTracker,
  PageTracker
}; 